import { http } from "@/helpers/http";
import Vue from 'vue'

const baseURL = 'https://vs7awp9fqh.execute-api.us-east-1.amazonaws.com/dev/v1/admin';
// const baseURL = 'http://localhost:3000/dev/v1/admin';

export default {
    namespaced: true,
    actions: {
        async login({ state, commit, rootState }, payload) {
            try {
                const { data } = await http.post(baseURL + "/auth/login", payload.data);
                if (data && data.token) {
                    http.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;
                    localStorage.setItem("_token", data.token);
                    return { status: true }
                }
            }
            catch (e) {
                console.log(e)
                return { status: false }
            }
        },

        logout({ state, commit, rootState }, payload) {
            // axios
            http.defaults.headers.common['Authorization'] = null;

            // local storage
            localStorage.removeItem("_token");

            if (payload.callback) payload.callback();
        },

        async fetchUsers({ state, commit, rootState }, payload) {
            try {
                const { data } = await http.get(`${baseURL}/users`, { params: payload.params })
                return { data, status: true }
            } catch (e) {
                console.log(e)
                return { status: false }
            }
        },

        async createUser({ state, commit, rootState }, payload) {
            try {
                const { data } = await http.post(`${baseURL}/users`, payload)
                return { data, status: true }
            } catch (e) {
                console.log(e)
                return { status: false }
            }
        },

        async updateUser({ state, commit, rootState }, payload) {
            try {
                const { data } = await http.put(`${baseURL}/users/${payload.id}`, payload.data)
                return { data, status: true }
            } catch (e) {
                console.log(e)
                return { status: false }
            }
        },

        async deleteUser({ state, commit, rootState }, payload) {
            try {
                const { data } = await http.delete(`${baseURL}/users/${payload.id}`)
                return { data, status: true }
            } catch (e) {
                console.log(e)
                return { status: false }
            }
        },
    }
}